// 300ms debounce lets a typed quantity (e.g. "12") settle before firing the first request.
// Rapid button clicks are coalesced by the _updateInFlight + _pendingUpdate queue in cart.js,
// so the debounce and the queue serve complementary roles: debounce handles typing, queue handles racing.
const ON_CHANGE_DEBOUNCE_TIMER = 300;

// Milliseconds before an inline cart error banner auto-dismisses.
const CART_ERROR_DISMISS_DELAY = 4000;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
